"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _ProductDetailContext = _interopRequireDefault(require("../context/ProductDetailContext"));
var _de = _interopRequireDefault(require("../../locals/de.json"));
var _en = _interopRequireDefault(require("../../locals/en.json"));
var _it = _interopRequireDefault(require("../../locals/it.json"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useDocuments = _ref => {
  let {
    lang = "de"
  } = _ref;
  const {
    productDetailData
  } = (0, _react.useContext)(_ProductDetailContext.default);
  const {
    documents: productDocuments
  } = productDetailData || {};
  const [documents, setDocuments] = (0, _react.useState)({});
  const [localsLoaded, setLocalsLoaded] = (0, _react.useState)(false);
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });
  (0, _react.useEffect)(() => {
    if (!(0, _isEmpty.default)(l("reactShop"))) {
      setLocalsLoaded(true);
    }
  }, [l]);
  (0, _react.useEffect)(() => {
    if (!productDocuments) return;
    setDocuments({
      title: l("reactShop.productDetail.title.documents"),
      items: productDocuments
    });
    return () => {
      setDocuments({});
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lang, localsLoaded, productDocuments]);
  return documents;
};
var _default = exports.default = useDocuments;